// The linkable providers, shared by Settings → Connected Accounts and the Account
// Settings dashboard card so the two can never disagree. Linking from Settings is
// not built for any of them, so both screens show each one as "Coming soon".
// (Signing IN with Google or Apple is a separate, real flow on the sign-in page.)
// X (Twitter) joined the list in 1.27.70 by owner ruling, as Coming soon.
import type { IconName } from '@/icons/names';

export interface ConnectedProvider {
  id: string;
  label: string;
  hint: string;
  icon: IconName;
  /** Shown as a tile on the Account Settings dashboard (the concept draws three). */
  onDashboard: boolean;
}

export const CONNECTED_PROVIDERS: ConnectedProvider[] = [
  {
    id: 'google',
    label: 'Google',
    hint: 'Sign in faster with your Google account.',
    icon: 'logo-google',
    onDashboard: true,
  },
  {
    id: 'apple',
    label: 'Apple',
    hint: 'Sign in with your Apple ID.',
    icon: 'logo-apple',
    onDashboard: true,
  },
  {
    id: 'x',
    label: 'X (Twitter)',
    hint: 'Link your X account.',
    icon: 'logo-x',
    onDashboard: true,
  },
  {
    id: 'github',
    label: 'GitHub',
    hint: 'For developers: link your GitHub identity.',
    icon: 'code',
    onDashboard: false,
  },
];
